import React from "react";
import { useNavigate } from "react-router-dom";
import { Map, LayoutGrid, Zap, Gauge, User } from "lucide-react";

/**
 * Mobile bottom navigation bar (visible only on <lg screens).
 * Positions items exactly per user requirement:
 * Harita / Liste / Hızlı Kayıt / AI / Profil
 */
const MobileBottomNav = ({ view, setView, onOpenQuickEntry }) => {
  const navigate = useNavigate();

  const items = [
    { id: "map", label: "Harita", icon: Map, action: () => setView("map") },
    { id: "list", label: "Liste", icon: LayoutGrid, action: () => setView("list") },
    { id: "quick", label: "Hızlı Kayıt", icon: Zap, action: onOpenQuickEntry, primary: true },
    { id: "ai-panel", label: "AI Panel", icon: Gauge, action: () => setView("ai-panel") },
    { id: "profile", label: "Ayarlar", icon: User, action: () => navigate("/settings") },
  ];

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 dark:bg-[#18181B]/95 backdrop-blur border-t border-[#E4E4E7] dark:border-[#27272A]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-label="Mobil Navigasyon"
    >
      <ul className="flex items-stretch justify-around">
        {items.map((it) => {
          const active = view === it.id;
          const Icon = it.icon;
          return (
            <li key={it.id} className="flex-1">
              <button
                data-testid={`mobile-nav-${it.id}`}
                onClick={it.action}
                className={`w-full h-full py-2 px-1 flex flex-col items-center justify-center gap-0.5 active:scale-95 transition ${
                  active
                    ? "text-[#F59E0B]"
                    : "text-[#52525B] dark:text-[#A1A1AA]"
                }`}
                aria-label={it.label}
              >
                <div
                  className={`${
                    it.primary
                      ? "w-9 h-9 rounded-full bg-gradient-to-br from-[#F59E0B] to-[#D97706] text-white flex items-center justify-center shadow"
                      : ""
                  }`}
                >
                  <Icon className={it.primary ? "w-5 h-5" : "w-5 h-5"} />
                </div>
                <span className="text-[10px] font-medium leading-none">{it.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
